import { useState } from "react";
import styles from "./Slider.module.css";
import leftArrow from "../../Icons/left.svg";
import rightArrow from "../../Icons/right.svg";

export default function SimpleSlider({ images }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  return (
    <div className={styles.sliderContainer}>
      <div className={styles.imageWrapper}>
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Slide ${index + 1}`}
            className={`${styles.image} ${
              index === currentIndex ? styles.active : styles.inactive
            }`}
          />
        ))}
      </div>

      {images.length > 1 && (
        <div className={styles.controlsContainer}>
          <button className={styles.arrowButton} onClick={prevSlide}>
            <img src={leftArrow} alt="Previous" />
          </button>
          <div className={styles.photoCarousel}>
            {currentIndex + 1} of {images.length}
          </div>
          <button className={styles.arrowButton} onClick={nextSlide}>
            <img src={rightArrow} alt="Next" />
          </button>
        </div>
      )}
    </div>
  );
}
